import { useState } from 'react'
import { Users, Plus } from 'lucide-react'
import { ClientList } from '@components/clients/ClientList'
import { ClientForm } from '@components/clients/ClientForm'
import { CsvImportWizard } from '@components/clients/CsvImportWizard'
import { Client } from '@/types'

export function ClientsPage() {
  const [showForm, setShowForm] = useState(false)
  const [showImport, setShowImport] = useState(false)
  const [editingClient, setEditingClient] = useState<Client | null>(null)

  const handleEdit = (client: Client) => {
    setEditingClient(client)
    setShowForm(true)
  }

  const handleCloseForm = () => {
    setShowForm(false)
    setEditingClient(null)
  }

  const handleFormSuccess = () => {
    // Form will handle closing itself after success
  }

  const handleImportSuccess = () => {
    // Import wizard will handle closing itself after success
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="icon-container icon-container-lg">
            <Users size={24} className="text-indigo-500" />
          </div>
          <h1 className="text-3xl font-bold text-slate-100">Clients</h1>
        </div>
        <button
          onClick={() => {
            setEditingClient(null)
            setShowForm(true)
          }}
          className="btn-primary"
        >
          <Plus size={20} />
          Add Client
        </button>
      </div>

      <ClientList
        onEdit={handleEdit}
        onImportClick={() => setShowImport(true)}
      />

      {showForm && (
        <ClientForm
          client={editingClient}
          onClose={handleCloseForm}
          onSuccess={handleFormSuccess}
        />
      )}

      {showImport && (
        <CsvImportWizard
          onClose={() => setShowImport(false)}
          onSuccess={handleImportSuccess}
        />
      )}
    </div>
  )
}
